import { computed } from "vue";
import { comboboxItemIndicatorClasses } from "./combobox.styles";
import { useCombobox } from "./useCombobox";

export const useComboboxItemIndicator = () => {
  const combobox = useCombobox();
  const classes = computed(() =>
    comboboxItemIndicatorClasses({ selected: combobox.isSelected.value ? "true" : "false" }),
  );
  return { classes };
};
